<template>
    <b-modal id="cost-unit-draft-edit-modal" hide-footer no-close-on-backdrop
        size="xl" title="Schadenpositionsentwurf bearbeiten"
        :visible="isModalOpen" @hide="hideReset()" @show="loadForm">
        <csp-desktop-info-card ref="costUnitDraftInfoCard"
            class="record-cost-unit-edit-modal"
            :cols="12"
            :form-context="formContext"
            icon="inticon-users"
            title="Kunde"
            @cancel-form="reset"
            @save="saveCostUnitDraftFormData">
            <csp-record-detail-cost-unit-basedata
                :form-context="formContext"
                :hide-for-group-options="hideForGroupOptions"
                :record-id="recordId"/>
        </csp-desktop-info-card>
    </b-modal>
</template>

<script>
    import Container from '@services/Container';
    import '@desktop/scss/components/record/document-upload-modal.scss';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import CostUnitBasedata from '@desktop/components/record/cost-unit/RecordCostUnitBasedata.vue';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'CostUnitDraftEditModal',
        components: {
            'csp-record-detail-cost-unit-basedata': CostUnitBasedata,
        },
        mixins: [FormDataMixin],
        props: {
            hideForGroupOptions: {
                type: Array,
                default: null,
            },
            costUnitDraftId: {
                type: Number,
                default: null,
            },
            isModalOpen: {
                type: Boolean,
                default: false,
            },
            recordId: {
                type: Number,
                required: true,
            },
        },
        emits: ['close', 'updated'],
        data() {
            return {
                lastPaymentTypeId: [],
            }
        },
        methods: {
            loadForm() {
                const loadFunction = () => {
                    return recordRepository.loadCostUnitDraft(this.recordId, this.costUnitDraftId);
                }
                this.loadFormData(loadFunction);
            },
            hideReset() {
                this.$refs.costUnitDraftInfoCard.cancelFormData();
            },
            reset() {
                this.formContext.isLoaded = false;
                this.$emit('close');
            },
            saveCostUnitDraftFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveCostUnitDraft(this.recordId, this.costUnitDraftId, postData);
                }
                this.saveFormData(formContext, saveFunction, false).then(() => {
                    this.$emit('updated');
                    this.reset();
                });
            },
        },
    }
</script>
